import React from "react";

/**
 * FancyTitle — simplified for the refined 1912 aesthetic.
 * Renders the text as-is. (Previously, it enlarged the first letter of each word
 * for a small-caps look; we now prefer cleaner letterpress typography.)
 */
export default function FancyTitle({ as: As = "span", children, className = "", ...rest }) {
  return (
    <As className={className} {...rest}>
      {children}
    </As>
  );
}
